import { MenuOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import React, { useCallback } from "react"

import { ImportButton } from "../../../../components/ImportButton.tsx"
import { SearchBar } from "../../../../components/Input/SearchBar.tsx"
import { type PermissionProjectPermissions } from "../../../SettingsPermissions/types/permissions.types.ts"
import { ProjectsLeadApprovalTrigger } from "../../ProjectsLeadApproval/ProjectsLeadApprovalTrigger.tsx"
import { useProjectsViewSwitch } from "../../helpers/projects-view-preference.ts"
import type { ProjectFilters } from "../../redux/projects.types.ts"

const { Title, Text } = Typography

interface ProjectListGridHeaderProps {
  projectPermissions: PermissionProjectPermissions
  search: string | null
  onFilersChange: (data: Partial<ProjectFilters>) => void
  onRefetchProjectsCallback: () => void
  onImport: (file: File) => Promise<void>
  onDownloadTemplate: () => Promise<void>
}

export function ProjectListGridHeader({
  projectPermissions,
  search,
  onFilersChange,
  onRefetchProjectsCallback,
  onImport,
  onDownloadTemplate
}: ProjectListGridHeaderProps) {
  const switchProjectsView = useProjectsViewSwitch()

  const onSearchHandler = useCallback(
    (q: string | null) => onFilersChange({ q }),
    [onFilersChange]
  )

  return (
    <Flex justify="space-between" wrap align="center" className={"mb-4"}>
      <div>
        <Title level={2} className="m-0 text-start">
          Projects
        </Title>
        <Text type="secondary">Visual overview of all company projects.</Text>
      </div>
      <Flex gap={8} wrap>
        <SearchBar
          placeholder="Search projects..."
          defaultValue={search || ""}
          onSearch={onSearchHandler}
        />

        {projectPermissions?.projects?.project_create && (
          <ImportButton
            onImport={onImport}
            onDownloadTemplate={onDownloadTemplate}
          />
        )}

        {projectPermissions?.projects?.project_create && (
          <ProjectsLeadApprovalTrigger
            onRefetchCallback={onRefetchProjectsCallback}
          />
        )}

        <Button
          type={"primary"}
          onClick={() => switchProjectsView("list")}
          icon={<MenuOutlined />}
        >
          View List
        </Button>
      </Flex>
    </Flex>
  )
}
